interface LogoProps {
  width?: number;
  height?: number;
  className?: string;
  iconOnly?: boolean;
}

export const Logo: React.FC<LogoProps> = ({
  width = 32,
  height = 32,
  className = "",
  iconOnly = false,
}) => {
  const logoSrc = iconOnly 
    ? "https://storage.googleapis.com/trainingmatrix/images/tmlogoiconv2.png"
    : "https://storage.googleapis.com/trainingmatrix/images/tmlogofullv2.png";
    
  return (
    <img 
      src={logoSrc} 
      alt="Ai Skills Matrix" 
      width={width}
      height={height}
      className={className}
    />
  );
};
